import React from 'react';
import * as PropTypes from 'prop-types';
import { Loading } from '../Loading/Loading';
import { ErrorBox } from '../Error/Error';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignOut } from '@whitebox-learning/fontawesome-pro-light-svg-icons';
import Button from 'react-bootstrap/Button';
import Alert from 'react-bootstrap/Alert';

import './AppChooser.sass';

const AppChooser = ({ apps, loading, error, chooseApp, logout }) => (
  <div className="app-chooser">
    <div className="header">
      <div>
        <h3>Choose an Application</h3>
      </div>
      <div>
        <Button variant="link" onClick={logout}>
          Logout <FontAwesomeIcon icon={faSignOut} />{' '}
        </Button>
      </div>
    </div>
    <div className="apps">
      {loading && <Loading title="Loading" message="Getting applications..." />}

      {apps.length ? (
        <div className="d-flex flex-wrap">
          {apps.map((app) => (
            <button
              key={app.code}
              className="app"
              onClick={() => chooseApp(app.code)}
              type="button"
              aria-label={`Launch ${app.name === 'Shelter' ? 'Survival Shelter' : app.name}`}
            >
              <img src={app.icon} alt="" aria-hidden="true" />
            </button>
          ))}
        </div>
      ) : (
        !error && (
          <Alert variant="danger">
            <Alert.Heading>Error: No apps found</Alert.Heading>
            <hr />
            <p>
              Your teacher has not set up any activities for your classroom.
            </p>
            <p>
              <b>Teachers:</b> You can set up activities for this classroom from
              your TCC. Please reach out to support@whiteboxlearning.com if you
              need further assistance.
            </p>
          </Alert>
        )
      )}
      {error !== undefined && (
        <ErrorBox error={error} title="Error Loading Applications">
          <p>
            We're sorry, there was an error loading the application list. Please
            reload the page to try again.
          </p>
          <p>If the error continues, please contact us.</p>
        </ErrorBox>
      )}
    </div>
  </div>
);

AppChooser.propTypes = {
  apps: PropTypes.array.isRequired,
  chooseApp: PropTypes.func.isRequired,
};
AppChooser.defaultProps = {
  apps: [],
};

export default AppChooser;
